import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { antes, despues } from '../data/content';
export function Comparison() {
  return <section aria-labelledby="comparativa" className="w-full bg-ink-raised" data-id="element-29" data-mp="1g8ud0y5t1pn7">
      <div className="mx-auto max-w-content px-5 py-16 lg:py-24" data-id="element-30" data-mp="1l6cpuzmy0p0h">
        <h2 id="comparativa" className="text-center font-display text-3xl text-cream sm:text-4xl" data-id="element-31" data-mp="1pxuh2vz5zb89">
          Antes y después de Memorias del Alma™
        </h2>

        <div className="mt-12 grid gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-32" data-mp="1uwxnokuslpic">
          <div className="flex h-full flex-col rounded-2xl border border-line bg-ink p-7 lg:p-9" data-id="element-33" data-mp="1zv8xwwp02213">
            <p className="font-display text-2xl text-cream/70" data-id="element-34" data-mp="23yyk5fi7c7iy">Antes de Memorias del Alma™</p>
            <p className="mt-2 text-[13px] uppercase tracking-[0.14em] text-muted" data-id="element-35" data-mp="28x8btg4pwpzt">
              El costo de la improvisación en sesión
            </p>
            <ul className="mt-7 flex-1 space-y-5" data-id="element-36" data-mp="9m8n4owjei7c">
              {antes.map(item => <li key={item} className="flex gap-3.5" data-id="element-37" data-mp="ejh6gstf8sa6">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-line text-muted" aria-hidden="true" data-id="element-38" data-mp="1m18wdye2yfw7">
                    <XIcon className="h-3 w-3" data-id="element-39" data-mp="1h7w67jtr611c" />
                  </span>
                  <span className="text-[15px] leading-relaxed text-muted" data-id="element-40" data-mp="1d96xw5nkn9ok">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex h-full flex-col rounded-2xl border border-amethyst/45 bg-[#170E28] p-7 lg:p-9" data-id="element-41" data-mp="187hk4i8yshws">
            <p className="font-display text-2xl text-gold" data-id="element-42" data-mp="20y9c13izykeb">Con Memorias del Alma™</p>
            <p className="mt-2 text-[13px] uppercase tracking-[0.14em] text-amethyst" data-id="element-43" data-mp="20w5csyw1m9kd">
              El sistema definitivo para el terapeuta
            </p>
            <ul className="mt-7 flex-1 space-y-5" data-id="element-44" data-mp="1qz0n4p2znvyt">
              {despues.map(item => <li key={item} className="flex gap-3.5" data-id="element-45" data-mp="kk9hy96u1oyz">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amethyst-deep text-cream" aria-hidden="true" data-id="element-46" data-mp="khn8g40dsze4">
                    <CheckIcon className="h-3 w-3" data-id="element-47" data-mp="h2vgw4eod3x7" />
                  </span>
                  <span className="text-[15px] leading-relaxed text-cream/90" data-id="element-48" data-mp="m1f4e98x2nro">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}